<script>
import DesktopLayout from '@layouts/desktop.vue';
import HomeDesktop from '@views/home/desktop/home-desktop.vue';
import HomeMobile from '@views/home/mobile/home-mobile.vue';
import MobileLayout from '@layouts/mobile.vue';
import CheckinDetails from '@components/checkin/checkin-details.vue';
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import {
  authComputed,
  authMethods,
  homeComputed,
  homeMethods,
  workoutComputed,
  workoutMethods,
  nutritionComputed,
  nutritionMethods,
} from '@state/helpers';

export default {
  components: {
    DesktopLayout,
    HomeDesktop,
    HomeMobile,
    MobileLayout,
    CheckinDetails,
  },
  mixins: [breakpointsMixin],
  data() {
    return {
      loading: false,
      showMobileCheckin: false,
    };
  },
  async created() {
    this.loading = true;
    if (!this.homeOverview || this.isWorkoutUpdate || this.isNutritionUpdated) {
      // Get new data if workout updated or no homeOverview
      await this.getHomeOverview();
      if (this.homeOverview && this.homeOverview.checkInNeedingClientInput) {
        this.$bvModal.show('checkin-modal');
      }
    }
    if (!this.progressDetails || this.isWorkoutUpdate || this.isNutritionUpdated) {
      // Get new data if workout updated or no progressDetails
      await this.getProgressDetails();
    }
    this.setIsNutritionUpdated(false);
    this.setIsWorkoutUpdated(false); // Set flag to false until the next workout update
    this.loading = false;
  },
  methods: {
    ...authMethods,
    ...homeMethods,
    ...workoutMethods,
    ...nutritionMethods,
  },
  computed: {
    ...authComputed,
    ...homeComputed,
    ...workoutComputed,
    ...nutritionComputed,
  },
};
</script>

<template>
  <div class="home-container">
    <DesktopLayout v-if="isDesktopView">
      <div v-if="loading || isLoadingExercise" class="loading-wrapper">
        <BaseLoadingSpinner />
      </div>
      <HomeDesktop v-if="homeOverview && progressDetails && !loading && !isLoadingExercise" />
    </DesktopLayout>

    <MobileLayout v-if="!isDesktopView && !showMobileCheckin">
      <div v-if="loading || isLoadingExercise || isLoadingProgress" class="loading-wrapper">
        <BaseLoadingSpinner />
      </div>
      <HomeMobile v-if="homeOverview && progressDetails && !loading && !isLoadingExercise && !isLoadingProgress" />
    </MobileLayout>
    <b-modal id="checkin-modal" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header>
      <CheckinDetails
        @show-mobile-checkin="
          () => {
            $bvModal.hide('checkin-modal');
            showMobileCheckin = true;
          }
        "
        @checkin-completed="
          () => {
            $bvModal.hide('checkin-modal');
            showMobileCheckin = false;
          }
        "
      />
    </b-modal>
    <CheckinDetails
      v-if="showMobileCheckin"
      :stepProp="1"
      @checkin-completed="
        () => {
          $bvModal.hide('checkin-modal');
          showMobileCheckin = false;
        }
      "
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable selector-id-pattern

.beta-callout {
  align-items: center;
  background-color: black;
  color: white;
  display: flex;
  font-size: 16px;
  font-weight: normal;
  justify-content: center;
  line-height: 20px;
  padding: 6px 5px;
  text-align: center;
}

.loading-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 30vh;
  position: absolute;
  width: 100%;

  ::v-deep .loading {
    height: 5rem;
    width: 5rem;
  }
}

::v-deep #checkin-modal {
  .modal-dialog {
    .modal-content {
      background-color: transparent;
      border: unset;
    }
  }
}
</style>
